import { RefObject } from 'react'

import { ColumnConfig, ColumnPinning } from '../DataGrid.types'
import { StickyController } from './StickyController'

export function getColumnPinning<RowType>(
  columnIndex: number,
  pinnedColumns: number,
  pinnedColumnsRight: number,
  columns: ColumnConfig<RowType>[],
) {
  if (!pinnedColumns && !pinnedColumnsRight) {
    return ColumnPinning.None
  }
  if (columnIndex < pinnedColumns) {
    return ColumnPinning.Left
  }
  if (columnIndex + 1 > columns.length - pinnedColumnsRight) {
    return ColumnPinning.Right
  }

  return ColumnPinning.None
}

export function getLeftRightVars(
  columnPinning: ColumnPinning,
  stickyControllerRef: RefObject<StickyController>,
  columnIndex: number,
) {
  if (columnPinning === ColumnPinning.Left) {
    const leftVar = stickyControllerRef.current?.getLeftVarForColumn(columnIndex)
    return { $leftVar: leftVar ? `left: var(${leftVar})` : `left: 0` }
  }
  if (columnPinning === ColumnPinning.Right) {
    const rightVar = stickyControllerRef.current?.getRightVarForColumn(columnIndex)
    return { $rightVar: rightVar ? `right: var(${rightVar})` : `right: 0` }
  }
  return {}
}
